import MessageComponent from './QiyiMessage.vue'

const Message = {}

Message.install = function (Vue) {
  const MessageConstructor = Vue.extend(MessageComponent)
  const instance = new MessageConstructor()

  instance.$mount(document.createElement('div'))
  document.body.appendChild(instance.$el)

  let timer

  const MsgMain = {
    showMessage(txt, type, callBack) {
      clearTimeout(timer)
      timer = setTimeout(() => {
        instance.visible = false
        typeof callBack === 'function' && callBack()
      }, 1500)
      instance.txt = txt
      instance.type = type
      instance.visible = true
    },
    success(txt, CB) {
      this.showMessage(txt, 'success', CB)
    },
    fail(txt, CB) {
      this.showMessage(txt, 'fail', CB)
    },
    warning(txt, CB) {
      this.showMessage(txt, 'warning', CB)
    }
  }

  Vue.prototype.$message = MsgMain
}

export default Message
